"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailAction = exports.DetailValuePrice = exports.DetailValue = exports.DetailKey = exports.Detail = exports.SectionContents = exports.SectionHeading = exports.Section = exports.SectionPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SectionPanel = function (_a) {
    var className = _a.className, id = _a.id, key = _a.key, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { id: "".concat(id !== null && id !== void 0 ? id : ""), className: "section-panel ".concat(className !== null && className !== void 0 ? className : ""), children: children }, "".concat(key !== null && key !== void 0 ? key : "")));
};
exports.SectionPanel = SectionPanel;
var Section = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.Section = Section;
var SectionHeading = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section-heading text-blue-green font-weight-semi-bold ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.SectionHeading = SectionHeading;
var SectionContents = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "section-contents ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.SectionContents = SectionContents;
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.Detail = Detail;
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-key ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.DetailKey = DetailKey;
var DetailValue = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
exports.DetailValue = DetailValue;
var DetailValuePrice = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value font-weight-semi-bold text-blue-1", children: children }));
};
exports.DetailValuePrice = DetailValuePrice;
var DetailAction = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)("button", __assign({}, props, { className: "hyperlink btn-text d-block mt-1", children: children })));
};
exports.DetailAction = DetailAction;
//# sourceMappingURL=SectionPanelTags.js.map